import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useHistory } from 'react-router-dom';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { FeatureAvailableIcon } from '../feature-table/SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommerceFeatureListItem = ({
  feature
}) => {
  const history = useHistory();
  const isMobile = useIsMobile();
  const featureNameKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.name`]);
  if (!featureNameKey) return null;
  const tooltipKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.description.${COMMERCE}`, `enrolledProductLine.features.${feature.shortName}.description.${COMMERCE}_jsx`, `enrolledProductLine.features.${feature.shortName}.description.default_jsx`]);
  const shortLimitKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.shortLimits.${COMMERCE}.FREE`, `enrolledProductLine.features.${feature.shortName}.shortLimits.default.FREE`, `enrolledProductLine.features.${feature.shortName}.shortLimits.${COMMERCE}.ADDITIONAL_SUBSCRIPTION`, `enrolledProductLine.features.${feature.shortName}.shortLimits.default.ADDITIONAL_SUBSCRIPTION`]);
  const {
    embeddedLink
  } = feature;
  const handleLinkClick = () => {
    if (embeddedLink) {
      const {
        isExternal,
        name,
        url
      } = embeddedLink;
      trackClickedLink({
        name,
        type: isExternal ? 'external' : 'internal',
        url
      });
      if (!isExternal && url) {
        history.push(url);
      }
    }
  };
  const tooltipContent = tooltipKey ? /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: tooltipKey,
      options: {
        onClick: handleLinkClick,
        href: embeddedLink && embeddedLink.url,
        external: embeddedLink && embeddedLink.isExternal
      },
      elements: {
        Link,
        br: 'br'
      }
    }), shortLimitKey && /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: shortLimitKey
      })
    })]
  }) : null;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    children: [/*#__PURE__*/_jsx(Text, {
      paddingInline: isMobile ? '200' : '400',
      children: /*#__PURE__*/_jsx(FeatureAvailableIcon, {
        padding: "100"
      })
    }), tooltipKey ? /*#__PURE__*/_jsx(Tooltip, {
      use: "longform",
      placement: isMobile ? 'top' : 'right',
      margin: isMobile ? undefined : '200',
      title: tooltipContent,
      children: /*#__PURE__*/_jsx(Text, {
        textDecoration: "underline dashed",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: featureNameKey
        })
      })
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: featureNameKey
    })]
  });
};